import { type EventEmitter, type FunctionalComponent, h } from '@stencil/core';
import { clickedElement } from '../uiaas-compare-bar-helpers';
import {CompareBarAreaType} from '../models/compare-bar-area-type.enum';

export interface CompareBarEventLayer {
  eventEmitter: EventEmitter;
  siteSearchKeyword: string;
  IDs: string;
  redirectionUrl: string;
  resultClickEventEmitter: EventEmitter;
}

export const CompareBarEventLayer: FunctionalComponent<CompareBarEventLayer> = (
  props,
  children
) => {
    const { eventEmitter, siteSearchKeyword, IDs, resultClickEventEmitter, redirectionUrl } = props;
    const onEnterEventEmitter = (e) => e.key === 'Enter' ? eventBuilder(e) : void 0;

    const eventBuilder = (e) => {
        const elementArea = clickedElement(e);

        if (elementArea !== CompareBarAreaType.ClearList && elementArea !== CompareBarAreaType.CompareNowButton)
          return;

        eventEmitter.emit({
          siteSearchKeyword,
          IDs,
          actionType: elementArea,
        });

        if(elementArea === CompareBarAreaType.CompareNowButton) {
          resultClickEventEmitter.emit({
            clickType: 'left',
            clickedArea: elementArea,
            openUrl: redirectionUrl,
            action: 'click',
            siteSearchKeyword
          });
        }
    };

    return (
      <host
        onMouseDown={(e) => eventBuilder(e)}
        onKeyDown={(e) => onEnterEventEmitter(e)}
      >
        {children}
      </host>
    );
};
